import axios from 'axios';
import { OverviewQuery } from '../../types';

class OverviewService {
  get = (props: any) => axios.get<OverviewQuery>('/overview', props);
}

export const overviewService = new OverviewService();
